import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrderConfirmationDetailsComponent } from './order-confirmation-details/order-confirmation-details.component';

const routes: Routes = [
  {
    path: 'order-confirmation/:id',
    component: OrderConfirmationDetailsComponent
  },
  {
    path: 'order-confirmation/bulk/:id',
    component: OrderConfirmationDetailsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedComponentsRoutingModule { }
